import React from "react";
import classNames from "classnames";
import "./inputAnimated.scss";

const InputAnimated = ({
    type = "text",
    value,
    onChange,
    placeholder,
    disabled = false,
    required = false,
    className = "",
    backgroundClass = "main-color", // Clase de fondo predeterminada
    readOnly = false,
    defaultChecked,
    step,
    checked,
    name,
    min,
    max,
    onInput,
    onKeyDown,
    maxLength,
}) => {
    const isCheckbox = type === "checkbox";
    const isTextarea = type === "textarea";

    const containerClass = classNames("input-container-animated", className, {
        "checkbox-container": isCheckbox,
        [backgroundClass]: backgroundClass,
    });

    return (
        <div className={containerClass}>
            {isTextarea ? (
                <textarea
                    name={name} 
                    className={classNames("txt-area", backgroundClass, className)}
                    value={value}
                    onChange={!readOnly ? onChange : undefined}
                    placeholder={placeholder}
                    disabled={disabled}
                    required={required}
                    readOnly={readOnly}
                />
            ) : (
                <>
                    <input
                        name={name} 
                        type={type}
                        className={classNames(
                            isCheckbox ? "checkbox" : "txt-inp",
                            backgroundClass,
                            className
                        )}
                        value={value}
                        onChange={!readOnly ? onChange : undefined}
                        placeholder=" "
                        disabled={disabled}
                        required={required}
                        readOnly={readOnly}
                        defaultChecked={defaultChecked}
                        step={step}
                        checked={checked}
                        min={min}
                        max={max}
                        onInput={onInput}
                        onKeyDown={onKeyDown}
                        maxLength={maxLength}
                    />
                    <label className={classNames(isCheckbox ? "check-label" : "input-label", backgroundClass)}>
                        {placeholder}
                    </label>
                </>
            )}
        </div>
    );
};

export default InputAnimated;
